import * as OrderStatus from '../../../Entities/OrderStatus'
import {WebData} from '../../../Data/WebData'
import {Customer} from '../../../Entities/Customer'
import {Company} from '../../../Entities/Company'
import {BpsUser} from '../../../Entities/BpsUser'
import {ShippingMethod} from '../../../Entities/ShippingMethod'
import {LocalDate} from 'js-joda'
import {OrderPaid} from '../../../Entities/OrderPaid'
import {OrderFilterType} from './OrderFilterType'

export type OrderFilterInput =
    | StatusFilterInput
    | CustomerFilterInput
    | BpsUserFilterInput
    | CompanyFilterInput
    | OrderNumberFilterInput
    | ShippingMethodFilterInput
    | DateFromFilterInput
    | DateToFilterInput
    | PriceFromFilterInput
    | PriceToFilterInput
    | OrderPaidFilterInput

interface StatusFilterInput {
    readonly type: 'StatusFilterInput'
    readonly value: OrderStatus.M | null
}

interface CustomerFilterInput {
    readonly type: 'CustomerFilterInput'
    readonly value: number | null
    readonly customers: WebData<Customer[]>
}

interface CompanyFilterInput {
    readonly type: 'CompanyFilterInput'
    readonly companySearch: string
    readonly companySuggestions: Company[]
    readonly selectedCompany: Company | null
}

interface BpsUserFilterInput {
    readonly type: 'BpsUserFilterInput'
    readonly bpsUserSearch: string
    readonly bpsUserSuggestions: BpsUser[]
    readonly selectedBpsUser: BpsUser | null
}

interface OrderNumberFilterInput {
    readonly type: 'OrderNumberFilterInput'
    readonly value: string | null
}

interface ShippingMethodFilterInput {
    readonly type: 'ShippingMethodFilterInput'
    readonly value: ShippingMethod | null
}

interface DateFromFilterInput {
    readonly type: 'DateFromFilterInput'
    readonly value: LocalDate | null
}

interface DateToFilterInput {
    readonly type: 'DateToFilterInput'
    readonly value: LocalDate | null
}

interface PriceFromFilterInput {
    readonly type: 'PriceFromFilterInput'
    readonly value: string
}

interface PriceToFilterInput {
    readonly type: 'PriceToFilterInput'
    readonly value: string
}

interface OrderPaidFilterInput {
    readonly type: 'OrderPaidFilterInput'
    readonly value: OrderPaid | null
}

export function fromFilterType(
    orderFilterType: OrderFilterType
): OrderFilterInput {
    switch (orderFilterType) {
        case 'Status':
            return {
                type: 'StatusFilterInput',
                value: null,
            }
        case 'Customer':
            return {
                type: 'CustomerFilterInput',
                value: null,
                customers: {
                    type: 'Loading',
                },
            }
        case 'Company':
            return {
                type: 'CompanyFilterInput',
                companySearch: '',
                companySuggestions: [],
                selectedCompany: null
            }
        case 'BpsUser':
            return {
                type: 'BpsUserFilterInput',
                bpsUserSearch: '',
                bpsUserSuggestions: [],
                selectedBpsUser: null,
            }
        case 'OrderNumber':
            return {
                type: 'OrderNumberFilterInput',
                value: null,
            }
        case 'ShippingMethod':
            return {
                type: 'ShippingMethodFilterInput',
                value: null,
            }
        case 'CreatedFrom':
            return {
                type: 'DateFromFilterInput',
                value: null,
            }
        case 'CreatedTo':
            return {
                type: 'DateToFilterInput',
                value: null,
            }
        case 'PriceFrom':
            return {
                type: 'PriceFromFilterInput',
                value: '',
            }
        case 'PriceTo':
            return {
                type: 'PriceToFilterInput',
                value: '',
            }
        case 'OrderPaid':
            return {
                type: 'OrderPaidFilterInput',
                value: null,
            }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/OrderFiltering/Model/OrderFilterInput.ts